import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';

import {CommonTransformationService, QueryResult, Transaction, WorklistType} from '@app/shared';
import {map} from "rxjs/operators";
import {SelectItem} from "primeng/api";

@Injectable()
export class WorklistDataService {

  constructor (private http: HttpClient, private transform: CommonTransformationService) { }

  getWorklist(type: WorklistType): Observable<QueryResult> {
    const url = `/approval/worklist/workitems/self?type=${type}`;

    return this.http.get<QueryResult>(url);
  }

  getWorklistCount(type: string): Observable<any> {
    const url = `/approval/worklist/status-counts?type=${type}`;

    return this.http.get(url);
  }

  getWorklistItemNextStatusAsDropdown(workItemId: number): Observable<SelectItem[]> {
    const url = `/approval/worklist/next-statuses?id=${workItemId}`;
    return this.http.get<QueryResult>(url).pipe(map(res => {
      return this.transform.convertToDropDown("name", res.list, "name");
    }));
  }

  getWorklistAttachments(workItemId: number): Observable<any> {
    const url = `/approval/worklist/workitem-attachments?id=${workItemId}`;
    return this.http.get(url);
  }
  getWorklistNotifications(workItemId: number): Observable<QueryResult> {
    const url = `/approval/worklist/workitem-notifications?id=${workItemId}`;
    return this.http.get<QueryResult>(url);
  }

  searchWorklist(params: HttpParams): Observable<QueryResult> {
    const url = '/approval/worklist/workitems/search?';     // need at least one one parameter
    return this.http.get<QueryResult>(url, {params: params});
  }


  updateWorklistItem(workItemId: number, selectedStatus: string, responseMessage: string): Observable<any> {
    const url = `/approval/worklist/workitems/${workItemId}`;

    return this.http.put(url, { selectedStatus: selectedStatus, responseMessage: responseMessage });
  }

  getJobRequisitionCandidateInfo(jrcId: number): Observable<any> {
    const url = `/recruiting/job-req-candidates/info?id=${jrcId}`;
    return this.http.get<any>(url);
  }

  checkIfContextUserIsApprover(txnType: Transaction| number, refId: number): Observable<Map<string, boolean>>{

    let url = `/approval/worklist/txn/approver?refId=${refId}&`;
    if (typeof txnType === "number") {
      url += `transactionId=${txnType}`;
    } else {
      url += `transaction=${txnType}`;
    }
	return this.http.get<Map<string, boolean>>(url);
	}

  getMyTasks(): Observable<QueryResult> {
    const url = `/todo/my-tasks`;
    return this.http.get<QueryResult>(url);
  }
}
